import React from 'react';
import { Navbar } from '../components/Navbar';
// import herobackground from '../assets/herobackground.jpg';
import women_empowerment from '../assets/women_empowerment.jpg'
import { FaHome } from "react-icons/fa";
import Footer from '../components/Footer';

const LoanRepayment = () => {
    return (
        <>
            {/* Hero Section */}
            <div
                style={{
                    background: `url(${women_empowerment}) no-repeat center center / cover`,
                    height: "70vh",
                    position: "relative",
                }}
            >
                <Navbar />
                <section
                    className="d-flex flex-column flex-lg-row align-items-center justify-content-between container-lg"
                    style={{
                        color: "white",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                    }}
                >
                    <div style={{ position: "relative", zIndex: 2, backgroundColor: "rgba(0,0,0,0.5)", padding: "20px 30px", borderRadius: "10px" }}>
                        <p style={{ fontSize: "1rem", letterSpacing: "1px", marginBottom: "10px" }}>
                            <FaHome className="text-info" /> <span style={{ color: "#00bfff" }}>Home</span> &gt; LOAN REPAYMENT
                        </p>
                        <h1 style={{ fontSize: "3rem", fontWeight: 700, margin: 0 }}>Loan Repayment</h1>
                    </div>
                </section>
            </div>

            {/* Loan Repayment Form Section */}
            <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10">
                            <div className="card shadow-sm p-4 p-md-5">
                                <h2
                                    className="mb-5 text-center fw-bold"
                                    style={{
                                        background: "linear-gradient(90deg, #00bfff, #0077b6)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                        fontSize: "2.8rem",
                                        textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
                                        position: "relative"
                                    }}
                                >
                                    Repay Your Loan
                                    <span
                                        style={{
                                            display: "block",
                                            width: "80px",
                                            height: "3px",
                                            backgroundColor: "#00bfff",
                                            margin: "10px auto 0",
                                            borderRadius: "2px"
                                        }}
                                    ></span>
                                </h2>

                                <form>
                                    <div className="mb-3">
                                        <label htmlFor="fullName" className="form-label">Full Name</label>
                                        <input type="text" className="form-control" id="fullName" placeholder="Enter your full name" />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="loanAccount" className="form-label">Loan Account Number</label>
                                        <input type="text" className="form-control" id="loanAccount" placeholder="Enter your loan account number" />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="loanType" className="form-label">Loan Type</label>
                                        <select className="form-select" id="loanType">
                                            <option value="">---Select---</option>
                                            <option value="personal">Personal Loan</option>
                                            <option value="Property">Loan Against Property Loan</option>
                                            <option value="Business">Business Loan</option>
                                            <option value="Housing">Housing & Consumer Loan</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="repaymentAmount" className="form-label">Repayment Amount</label>
                                        <input type="number" className="form-control" id="repaymentAmount" placeholder="Enter repayment amount" />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="paymentMode" className="form-label">Payment Mode</label>
                                        <select className="form-select" id="paymentMode">
                                            <option value="">---Select---</option>
                                            <option value="online">Online Transfer</option>
                                            <option value="bank">Bank Deposit</option>
                                            <option value="cheque">Cheque</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone Number</label>
                                        <input type="tel" className="form-control" id="phone" placeholder="Enter your phone number" />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="receipt" className="form-label">Upload Payment Receipt</label>
                                        <input type="file" className="form-control" id="receipt" />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description / Notes</label>
                                        <textarea className="form-control" id="description" rows="4" placeholder="Optional notes or transaction details"></textarea>
                                    </div>

                                    <div className="text-center">
                                        <button type="submit" className="btn btn-info btn-lg px-5">PAY NOW</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default LoanRepayment;
